<template>
  <label class="container">
    <input type="checkbox" v-on:click="change" v-model="bind" />
    <span v-bind:style="{ backgroundColor: background }" class="checkmark"></span>
  </label>
</template>

<script>
export default {
  name: 'checkbox',
  props: ['bind', 'size', 'background'],
  methods: {
    change() {
      this.$emit('change');
    },
  },
};
</script>

<style scoped>
/* The container */
.container {
  display: inline;
  position: relative;
  padding-left: 1.3em;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  border: solid 1px lightgray;
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: inline;
}
/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 8px;
  top: 4px;
  width: 6px;
  height: 12px;
  border: solid black;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.container .sizeCheckMark-1:after {
  left: 5px;
  top: 2px;
  width: 3px;
  height: 6px;
}

.sizeCheckMark-1 {
  height: 12px;
  width: 12px;
}

.container .sizeCheckMark-2:after {
  left: 9px;
  top: 4px;
  width: 6px;
  height: 12px;
}

.sizeCheckMark-2 {
  height: 25px;
  width: 25px;
}
</style>
